import { NgxMatColorPickerInput, Color } from "@angular-material-components/color-picker";
import { AfterViewInit, Component, Inject, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PreFilter, SubHeaders, US_ReportEmbeddedType, US_ReportStandardLayout, US_ReportstandardType } from "../../api/models";
import { DialogResult, DialogResultType } from "../DialogResult";
import { MessageDialogComponent } from "../message-dialog/message-dialog.component";

export interface ReportEmbeddedExportPropsDialogData {
  dialogTitle: string;
  reportEmbeddedExportId: number;
  preFilterId?: number;
  subscriptionId?: number;
  name?: string;
  reportPage?: string;
  disabled: boolean;

  reportEmbeddedType: US_ReportEmbeddedType;
  preFilters: PreFilter[];
}

@Component({
  selector: 'report-embedded-export-props-dialog',
  templateUrl: './report-embedded-export-props-dialog.component.html',
  styleUrls: ['./report-embedded-export-props-dialog.component.css']
})
export class ReportEmbeddedExportPropsDialogComponent {
  public Result: DialogResult;
  public selectedReportPage: string;
  public availablePages: string[];
  public embedName: string = '<NEW EMBED>';
  public preFilters: PreFilter[] = [];
  public preFilterId: number = -1;
  public subscriptions: SubHeaders[];
  public subscriptionId: number = -1;
  public disabled: boolean;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ReportEmbeddedExportPropsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReportEmbeddedExportPropsDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;

    this.availablePages = this.loadReportPages(this.data.reportEmbeddedType.reportPages);
    this.subscriptions = this.data.reportEmbeddedType.subscriptions;
    this.preFilters = this.data.preFilters;
    this.embedName = this.data.name;
    this.preFilterId = this.data.preFilterId;
    this.subscriptionId = this.data.subscriptionId;
    this.disabled = this.data.disabled;
    this.selectedReportPage = this.data.reportPage;

    if (this.subscriptionId === -1) {
      this.subscriptionId = this.subscriptions[0].subscriptionId;
    }
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    if (this.validateForm()) {
      this.data.name = this.embedName;
      this.data.preFilterId = this.preFilterId;
      this.data.subscriptionId = this.subscriptionId;
      this.data.name = this.embedName;
      this.data.disabled = this.disabled;
      this.data.reportPage = this.selectedReportPage;

      this.Result.ResultType = DialogResultType.Ok;
      this.Result.ResultData = this.data;

      this.dialogRef.close(this.Result);
    }
  }

  loadReportPages(reportPagesString: string): string[] {
    if (reportPagesString == null || reportPagesString.length > 0) {
      return reportPagesString.split(",");
    }

    return [];
  }  

  validateForm(): boolean {
    if (this.embedName.trim() == '') return this.showValidationError("Name required");
    if (this.selectedReportPage.trim()  == '') return this.showValidationError("Report page required");
    if (this.subscriptionId == -1) return this.showValidationError("Subscription selection required")
    return true;
  }

  showValidationError(errorMessage: string): boolean {
    MessageDialogComponent.showDialog(
      this.dialog,
      "Validation Error",
      errorMessage
    );

    return false;
  }
}
